import * as React from 'react'
import { SVGProps } from 'react'

const ShrinkIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='#fff'
        viewBox='0 0 24 24'
        strokeWidth={1.5}
        stroke='#fff'
        className='w-6 h-6'
        {...props}
    >
        <title>Shrink</title>
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25'
        />
    </svg>
)

export default ShrinkIcon
